<ng-container *ngIf="addingKeyword; else notAddingKeyword">
  <div class="row justify-content-start">
    <ng-container *ngIf="isAreaFirst; else areaLast">
      <ng-container *ngIf="!customer.IsCampaignNational">
        <div class="col-auto">
          <ng-container *ngTemplateOutlet="area"></ng-container>
        </div>
        <div class="col-auto">
          <ng-container *ngTemplateOutlet="toggleArea"></ng-container>
        </div>
      </ng-container>
      <div class="col-auto">
        <ng-container *ngTemplateOutlet="keyword"></ng-container>
      </div>
    </ng-container>
    <ng-template #areaLast>
      <div class="col-auto">
        <ng-container *ngTemplateOutlet="keyword"></ng-container>
      </div>
      <ng-container *ngIf="!customer.IsCampaignNational">
        <div class="col-auto">
          <ng-container *ngTemplateOutlet="toggleArea"></ng-container>
        </div>
        <div class="col-auto">
          <ng-container *ngTemplateOutlet="area"></ng-container>
        </div>
      </ng-container>
    </ng-template>
    <div class="col-auto">
      <button type="button" class="btn btn-primary" (click)="addKeyword()"><i class="fas fa-plus"></i>Keyword</button>
    </div>
    <div class="col-auto">
      <button type="button" class="btn btn-warning" (click)="toggleAddingKeyword()">Cancel</button>
    </div>
  </div>
</ng-container>

<ng-template #notAddingKeyword>
  <div class="d-flex">
    <div class="p-2">
      <button class="btn btn-primary btn-sm" 
        (click)="toggleAddingKeyword()" 
        [disabled]="websiteUrl?.IsReadOnly || restrictions.includes(customerCampaignRestrictionTypes_ReadOnly) || maximumKeywordsAdded"
        [title]="maximumKeywordsAdded ? 'Maximum number of tracking keywords added (' + (keywordConfig?.MaximumTrackingKeywords || defaultMaximumTrackingKeywords) + ')' : ''">
        <i class="fas fa-plus"></i>Keyword
      </button>
    </div>
    @if (!this.websiteUrl) {
      <div class="p-2 ms-auto">
        <ng-container *ngTemplateOutlet="csvExample"></ng-container>
        @if (canImportInitialRank) {
          <ng-container *ngTemplateOutlet="export"></ng-container>
          <div class="d-inline-block" ngbDropdown #drop="ngbDropdown">
            <button class="btn btn-primary btn-sm" type="button" (click)="drop.open()"
              [disabled]="websiteUrl?.IsReadOnly || restrictions.includes(customerCampaignRestrictionTypes_ReadOnly)">
              <i class="fa fa-upload"></i>Import Keywords
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownManual">
              <a ngbDropdownItem class="cursor-pointer" (click)="openFileImport(fileImport_WithInitialRank)">With Initial Rank</a>
              <a ngbDropdownItem class="cursor-pointer" (click)="openFileImport(fileImport_Standard)">Without Initial Rank</a>
            </div>
          </div>
        }
        @else {
          <button class="btn btn-primary btn-sm" type="button" 
            (click)="openFileImport(fileImport_Standard)" 
            [disabled]="websiteUrl?.IsReadOnly || restrictions.includes(customerCampaignRestrictionTypes_ReadOnly) || maximumKeywordsAdded"
            [title]="maximumKeywordsAdded ? 'Maximum number of tracking keywords added (' + (keywordConfig?.MaximumTrackingKeywords || defaultMaximumTrackingKeywords) + ')' : ''">
            <i class="fa fa-upload"></i>Import Keywords
          </button>
        }
        <input #fileInput type='file' accept=".csv" (change)="importTrackingKeywords($event)" hidden>
      </div>
    }
  </div>
</ng-template>

<ng-template #keyword>
  <div class="input-group mb-0" [formValidation]="formGroup">
    <span class="input-group-text">Keyword</span>
    <input #keywordInput type="text" class="form-control" [formControl]="keywordControl"
      [formValidation]="keywordControl" (keyup.enter)="addKeyword()"/>
  </div>
</ng-template>

<ng-template #area>
  <div class="input-group mb-0" [formValidation]="formGroup">
    <span class="input-group-text">Location</span>
    <input #areaInput type="text" class="form-control" [formControl]="areaControl"
      [formValidation]="areaControl" (keyup.enter)="addKeyword()" />
  </div>
</ng-template>

<ng-template #toggleArea>
  <button tabindex="-1" type="button" class="btn btn-primary" (click)="toggleAreaPosition()">
    <i class="fas fa-arrow-right-arrow-left fa-no-margin"></i>
  </button>
</ng-template>

<ng-template #csvExample>
  @if (canImportInitialRank) {
    <div class="d-inline-block me-2" ngbDropdown #drop="ngbDropdown">
      <a class="btn btn-link" (click)="drop.open()">Example {{customer.IsCampaignNational ? 'National' : 'Local'}} CSV</a>
      <div ngbDropdownMenu aria-labelledby="dropdownManual">
        @if (customer.IsCampaignNational) {
          <a ngbDropdownItem [attr.href]="nationalCampaignInitialRankExampleCsv" target="_blank">With Initial Rank</a>
          <a ngbDropdownItem [attr.href]="nationalCampaignExampleCsv" target="_blank">Without Initial Rank</a>
        }
        @else {
          <a ngbDropdownItem [attr.href]="localCampaignInitialRankExampleCsv" target="_blank">With Initial Rank</a>
          <a ngbDropdownItem [attr.href]="localCampaignExampleCsv" target="_blank">Without Initial Rank</a>
        }
      </div>
    </div>
  }
  @else if (customer.IsCampaignNational) {
    <a [attr.href]="nationalCampaignExampleCsv" target="_blank" class="me-2">Example National CSV</a>
  }
  @else {
    <a [attr.href]="localCampaignExampleCsv" target="_blank" class="me-2">Example Local CSV</a>
  }
</ng-template>

<ng-template #export>
  <button class="btn btn-primary btn-sm me-2" type="button" (click)="exportTrackingKeywordsWithInitialRank()" 
    [disabled]="websiteUrl?.IsReadOnly || restrictions.includes(customerCampaignRestrictionTypes_ReadOnly)">
    <i class="fa fa-download"></i>Export Keywords
  </button>
</ng-template>